import EllipsisAndLook from './EllipsisAndLook';
EllipsisAndLook.install = (Vue)=>{
    Vue.components(EllipsisAndLook.name,EllipsisAndLook)
}
export default EllipsisAndLook
